const HERO_IMG =
  "https://images.unsplash.com/photo-1680992046626-418f7e910589?auto=format&fit=crop&w=900&q=80";

export default function Hero({ onBookDemo }) {
  return (
    <header
      id="top"
      className="py-20 md:py-28 px-6 border-b border-linen"
      data-testid="hero-section"
    >
      <div className="max-w-6xl mx-auto sl-fade">
        <div className="grid md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-7">
            <span className="font-mono text-xs uppercase tracking-widest text-clay font-bold block mb-4">
              Architecture of Record
            </span>
            <h1
              className="font-display text-4xl md:text-6xl font-normal leading-[1.05] text-ink mb-6"
              style={{ textWrap: "balance" }}
              data-testid="hero-headline"
            >
              <span className="sl-line">
                <span>Unified enterprise LLM control</span>
              </span>
              <span className="sl-line">
                <span>within private infrastructure</span>
              </span>
            </h1>
            <p
              className="font-body text-lg text-umber max-w-lg leading-relaxed mb-8"
              data-testid="hero-subline"
            >
              Governed orchestration for enterprise models and autonomous agents.
              Zero data leakage across sovereign clouds.
            </p>
            <div className="flex items-center gap-4 flex-wrap">
              <button
                type="button"
                onClick={onBookDemo}
                className="font-mono text-xs uppercase tracking-widest px-6 py-3.5 bg-clay text-white hover:bg-clay-deep transition-colors"
                data-testid="hero-schedule-briefing-btn"
              >
                Schedule Architecture Briefing
              </button>
              <span className="font-mono text-[11px] text-stone">
                SOC 2 &bull; HIPAA Verified
              </span>
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="sl-wipe relative rounded-none border border-ink p-2 bg-ivory shadow-lg">
              <div className="relative aspect-[4/5] overflow-hidden bg-espresso">
                <img
                  src={HERO_IMG}
                  alt="The SureLoom private orchestration gateway"
                  className="absolute inset-0 w-full h-full object-cover sl-drift sl-grade"
                  data-testid="hero-image"
                />
                <svg
                  className="absolute inset-0 w-full h-full opacity-20 pointer-events-none"
                  aria-hidden="true"
                >
                  <filter id="sl-grain">
                    <feTurbulence
                      type="fractalNoise"
                      baseFrequency="0.75"
                      numOctaves="3"
                      stitchTiles="stitch"
                    />
                  </filter>
                  <rect width="100%" height="100%" filter="url(#sl-grain)" />
                </svg>
                <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-black/80 to-transparent text-white">
                  <span className="font-mono text-[11px] uppercase tracking-widest text-linen block mb-1">
                    Figure 1.0
                  </span>
                  <p className="font-display text-sm italic text-slate-200">
                    The SureLoom private orchestration gateway
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
